export function findVirtualSupplyLinkFor(formNumber: string) {
    return `https://secure02.principal.com/publicvsupply/GetFile?fm=${formNumber}&ty=VOP&EXT=.VOP`;
}

export function findFormLinkForDownload(formNumber: string) {
    return `https://secure05.principal.com/document-download/api/v1/public/document/${formNumber}`;
}